// import { useEffect, useRef } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { Label } from './utils';

// gsap.registerPlugin(ScrollTrigger);

// // ─── Data ────────────────────────────────────────────────────────────────────
// const REVIEWS = [
//   {
//     id: '01',
//     name: 'Arjun Mehta',
//     role: 'Founder, Orbit Labs',
//     text: 'Naveen has a rare instinct for turning vague briefs into something that feels inevitable. Every animation, every hover state — nothing felt like a default.',
//     tag: 'UI/UX',
//     year: '2024',
//   },
//   {
//     id: '02',
//     name: 'Sarah Lindström',
//     role: 'Creative Director, Helix Studio',
//     text: 'The portfolio site he built us stopped people mid-scroll. We got three new client inquiries the week it launched, all citing the site directly.',
//     tag: 'Frontend Dev',
//     year: '2024',
//   },
//   {
//     id: '03',
//     name: 'Kabir Nair',
//     role: 'CTO, Stackfield',
//     text: 'Technically sharp and visually fluent — an unusual combination. He rebuilt our admin panel from the ground up and the performance gains were immediate.',
//     tag: 'Full Stack',
//     year: '2023',
//   },
//   {
//     id: '04',
//     name: 'Priya Rajan',
//     role: 'Head of Product, Nomad OS',
//     text: 'What stood out was the attention to micro-interactions. Every transition felt earned. He pushed back on two of my ideas and was right both times.',
//     tag: 'Product Design',
//     year: '2023',
//   },
//   {
//     id: '05',
//     name: 'Tom Breckenridge',
//     role: 'Lead Engineer, Vanta Systems',
//     text: 'Clean, maintainable React. The GSAP work was surgical — no bloat, no jank. Rare to find someone who cares about the code as much as the output.',
//     tag: 'React / GSAP',
//     year: '2023',
//   },
// ];

// // Deterministic tilts so they don't randomise on re-render
// const TILTS   = [-4, 2.5, -1.5, 3, -2];
// const OFFSETS = [0, -6, 4, -3, 5]; // px vertical seat variation

// // ─── Component ───────────────────────────────────────────────────────────────
// export default function Reviews({ loaded, isMobile }) {
//   const wrapperRef = useRef(null);
//   const sectionRef = useRef(null);
//   const cardRefs   = useRef([]);

//   useEffect(() => {
//     if (!loaded) return;

//     const cards = cardRefs.current;
//     const total = cards.length;

//     // ── Starting positions: all cards off-screen right, stacked identically
//     cards.forEach((card, i) => {
//       gsap.set(card, {
//         x:        '120vw',
//         y:        OFFSETS[i],
//         rotation: TILTS[i],
//         zIndex:   i,
//         opacity:  1,
//       });
//     });

//     const ctx = gsap.context(() => {

//       // ── Pin the section for the full scroll height ──────────────────────
//       ScrollTrigger.create({
//         trigger:    wrapperRef.current,
//         start:      'top top',
//         end:        'bottom bottom',
//         pin:        sectionRef.current,
//         pinSpacing: false,
//       });

//       // ── Main animation driver ────────────────────────────────────────────
//       ScrollTrigger.create({
//         trigger: wrapperRef.current,
//         start:   'top top',
//         end:     'bottom bottom',
//         scrub:   1.6,
//         onUpdate(self) {
//           const p = self.progress;

//           // Cards fly in one by one from the right and stay stacked
//           cards.forEach((card, i) => {
//             const landStart = i / total;
//             const landP     = Math.max(0, Math.min(1, (p - landStart) / (1 / total)));
//             const eL        = easeOutBack(landP);

//             gsap.set(card, {
//               x:        window.innerWidth * 1.2 * (1 - eL),
//               y:        OFFSETS[i],
//               rotation: TILTS[i],
//               zIndex:   i,
//               opacity:  1,
//             });
//           });
//         },
//       });

//     }, wrapperRef);

//     return () => ctx.revert();
//   }, [loaded, isMobile]);

//   return (
//     <div
//       ref={wrapperRef}
//       id="reviews"
//       style={{
//         height:   isMobile ? '220vh' : '250vh',
//         position: 'relative',
//       }}
//     >
//       <section
//         ref={sectionRef}
//         data-cursor-text="Scroll&#10;Slowly"
//         style={{
//           background:    'var(--black)',
//           position:      'relative',
//           overflow:      'hidden',
//           padding:       isMobile ? '3rem 5vw 2rem' : '5rem 5vw',
//           height:        '100vh',
//           display:       'flex',
//           flexDirection: 'column',
//           boxSizing:     'border-box',
//         }}
//       >
//         {/* ── Header ─────────────────────────────────────────────────────── */}
//         <div style={{ position: 'relative', zIndex: 20, flexShrink: 0 }}>
//           <Label n="03" text="Reviews" />

//           <div style={{
//             display:        'flex',
//             alignItems:     isMobile ? 'flex-start' : 'baseline',
//             flexDirection:  isMobile ? 'column' : 'row',
//             justifyContent: 'space-between',
//             gap:            isMobile ? '0.4rem' : '1rem',
//             marginBottom:   isMobile ? '1.5rem' : '2.5rem',
//           }}>
//             <div style={{
//               fontFamily:    'Syne, sans-serif',
//               fontSize:      isMobile
//                 ? 'clamp(1.6rem, 8vw, 2.2rem)'
//                 : 'clamp(2rem, 4vw, 3.2rem)',
//               fontWeight:    800,
//               letterSpacing: '-0.05em',
//               lineHeight:    0.9,
//               color:         'var(--white)',
//             }}>
//               Kind <span style={{ color: 'var(--acid)' }}>Words</span>
//             </div>

//             <div style={{
//               fontFamily:    'Space Mono, monospace',
//               fontSize:      isMobile ? '0.44rem' : '0.5rem',
//               color:         '#333',
//               letterSpacing: '0.18em',
//               textTransform: 'uppercase',
//             }}>
//               {REVIEWS.length} testimonials
//             </div>
//           </div>

//           <div style={{ height: '1px', background: '#131313', marginBottom: isMobile ? '1.5rem' : '2.5rem' }} />
//         </div>

//         {/* ── Card stack stage ────────────────────────────────────────────── */}
//         <div style={{
//           position:   'relative',
//           zIndex:     10,
//           flex:       1,
//           display:    'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//         }}>
//           {REVIEWS.map((review, i) => (
//             <ReviewCard
//               key={review.id}
//               review={review}
//               ref={el => cardRefs.current[i] = el}
//               isMobile={isMobile}
//             />
//           ))}
//         </div>

//         {/* ── Footer hint ─────────────────────────────────────────────────── */}
//         <div style={{
//           position:      'absolute',
//           bottom:        isMobile ? '1.5rem' : '2rem',
//           right:         '5vw',
//           fontFamily:    'Space Mono, monospace',
//           fontSize:      '0.38rem',
//           color:         '#1c1c1c',
//           letterSpacing: '0.16em',
//           textTransform: 'uppercase',
//         }}>
//           Scroll to read
//         </div>
//       </section>
//     </div>
//   );
// }

// // ─── Card ─────────────────────────────────────────────────────────────────────
// import { forwardRef } from 'react';

// const ReviewCard = forwardRef(function ReviewCard({ review, isMobile }, ref) {
//   const cardW = isMobile ? 'min(82vw, 340px)' : 'min(44vw, 520px)';

//   return (
//     <div
//       ref={ref}
//       style={{
//         position:     'absolute',
//         width:        cardW,
//         background:   '#0b0b0b',
//         border:       '1px solid #1a1a1a',
//         borderRadius: '6px',
//         padding:      isMobile ? '1.4rem 1.2rem' : '2.2rem 2rem',
//         boxSizing:    'border-box',
//         willChange:   'transform',
//         // Shadow so stacked cards feel physical
//         boxShadow:    '0 12px 60px rgba(0,0,0,0.6), 0 2px 8px rgba(0,0,0,0.4)',
//       }}
//     >
//       {/* Top row: index + tag */}
//       <div style={{
//         display:        'flex',
//         justifyContent: 'space-between',
//         alignItems:     'center',
//         marginBottom:   isMobile ? '1rem' : '1.6rem',
//       }}>
//         <span style={{
//           fontFamily:    'Space Mono, monospace',
//           fontSize:      '0.38rem',
//           color:         '#222',
//           letterSpacing: '0.14em',
//         }}>
//           {review.id}
//         </span>
//         <span style={{
//           fontFamily:    'Space Mono, monospace',
//           fontSize:      '0.38rem',
//           color:         'var(--acid)',
//           letterSpacing: '0.18em',
//           textTransform: 'uppercase',
//           border:        '1px solid #1e2800',
//           borderRadius:  '2px',
//           padding:       '0.2rem 0.5rem',
//         }}>
//           {review.tag}
//         </span>
//       </div>

//       {/* Quote mark */}
//       <div style={{
//         fontFamily:    'Syne, sans-serif',
//         fontSize:      isMobile ? '2.4rem' : '3.5rem',
//         lineHeight:    0.7,
//         color:         '#151515',
//         marginBottom:  isMobile ? '0.6rem' : '0.8rem',
//         userSelect:    'none',
//       }}>
//         "
//       </div>

//       {/* Review text */}
//       <p style={{
//         fontFamily:   'Space Mono, monospace',
//         fontSize:     isMobile
//           ? 'clamp(0.5rem, 2.2vw, 0.65rem)'
//           : 'clamp(0.6rem, 1vw, 0.78rem)',
//         lineHeight:   1.8,
//         color:        'var(--white)',
//         opacity:      0.75,
//         margin:       0,
//         marginBottom: isMobile ? '1.2rem' : '2rem',
//       }}>
//         {review.text}
//       </p>

//       {/* Divider */}
//       <div style={{ height: '1px', background: '#131313', marginBottom: isMobile ? '0.8rem' : '1.2rem' }} />

//       {/* Reviewer info */}
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
//         <div>
//           <div style={{
//             fontFamily:    'Syne, sans-serif',
//             fontSize:      isMobile ? '0.6rem' : '0.75rem',
//             fontWeight:    700,
//             color:         'var(--white)',
//             letterSpacing: '-0.02em',
//             marginBottom:  '0.15rem',
//           }}>
//             {review.name}
//           </div>
//           <div style={{
//             fontFamily:    'Space Mono, monospace',
//             fontSize:      '0.38rem',
//             color:         '#444',
//             letterSpacing: '0.06em',
//           }}>
//             {review.role}
//           </div>
//         </div>

//         <span style={{
//           fontFamily:    'Space Mono, monospace',
//           fontSize:      '0.38rem',
//           color:         '#1c1c1c',
//           letterSpacing: '0.1em',
//         }}>
//           {review.year}
//         </span>
//       </div>
//     </div>
//   );
// });

// // ─── Easings ──────────────────────────────────────────────────────────────────
// function easeOutBack(t) {
//   const c1 = 1.70158;
//   const c3 = c1 + 1;
//   return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
// }

import { useEffect, useRef, forwardRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Label } from './utils';

gsap.registerPlugin(ScrollTrigger);

// ─── Data ────────────────────────────────────────────────────────────────────
const REVIEWS = [
  {
    id: '01',
    name: 'Arjun Mehta',
    role: 'Founder, Orbit Labs',
    text: 'Naveen has a rare instinct for turning vague briefs into something that feels inevitable. Every animation, every hover state — nothing felt like a default.',
    tag: 'UI/UX',
    year: '2024',
  },
  {
    id: '02',
    name: 'Sarah Lindström',
    role: 'Creative Director, Helix Studio',
    text: 'The portfolio site he built us stopped people mid-scroll. We got three new client inquiries the week it launched, all citing the site directly.',
    tag: 'Frontend Dev',
    year: '2024',
  },
  {
    id: '03',
    name: 'Kabir Nair',
    role: 'CTO, Stackfield',
    text: 'Technically sharp and visually fluent — an unusual combination. He rebuilt our admin panel from the ground up and the performance gains were immediate.',
    tag: 'Full Stack',
    year: '2023',
  },
  {
    id: '04',
    name: 'Priya Rajan',
    role: 'Head of Product, Nomad OS',
    text: 'What stood out was the attention to micro-interactions. Every transition felt earned. He pushed back on two of my ideas and was right both times.',
    tag: 'Product Design',
    year: '2023',
  },
  {
    id: '05',
    name: 'Tom Breckenridge',
    role: 'Lead Engineer, Vanta Systems',
    text: 'Clean, maintainable React. The GSAP work was surgical — no bloat, no jank. Rare to find someone who cares about the code as much as the output.',
    tag: 'React / GSAP',
    year: '2023',
  },
];

const TILTS   = [-4, 2.5, -1.5, 3, -2];
const OFFSETS = [0, -6, 4, -3, 5];

// ─── Component ───────────────────────────────────────────────────────────────
export default function Reviews({ loaded, isMobile }) {
  const wrapperRef = useRef(null);
  const sectionRef = useRef(null);
  const cardRefs   = useRef([]);

  useEffect(() => {
    if (!loaded) return;

    const cards = cardRefs.current;
    const total = cards.length;

    cards.forEach((card, i) => {
      gsap.set(card, {
        x:        '120vw',
        y:        OFFSETS[i],
        rotation: TILTS[i],
        zIndex:   i,
        opacity:  1,
      });
    });

    const ctx = gsap.context(() => {

      ScrollTrigger.create({
        trigger:    wrapperRef.current,
        start:      'top top',
        end:        'bottom bottom',
        pin:        sectionRef.current,
        pinSpacing: false,
      });

      ScrollTrigger.create({
        trigger: wrapperRef.current,
        start:   'top top',
        end:     'bottom bottom',
        scrub:   1.6,
        onUpdate(self) {
          const p = self.progress;

          cards.forEach((card, i) => {
            const landStart = i / total;
            const landP     = Math.max(0, Math.min(1, (p - landStart) / (1 / total)));
            const eL        = easeOutBack(landP);

            gsap.set(card, {
              x:        window.innerWidth * 1.2 * (1 - eL),
              y:        OFFSETS[i],
              rotation: TILTS[i],
              zIndex:   i,
              opacity:  1,
            });
          });
        },
      });

    }, wrapperRef);

    return () => ctx.revert();
  }, [loaded, isMobile]);

  return (
    <div
      ref={wrapperRef}
      id="reviews"
      style={{
        height:   isMobile ? '220vh' : '250vh',
        position: 'relative',
      }}
    >
      <section
        ref={sectionRef}
        data-cursor-text="Scroll&#10;Slowly"
        style={{
          background:    'var(--black)',
          position:      'relative',
          overflow:      'hidden',
          padding:       isMobile ? '3rem 5vw 2rem' : '5rem 5vw',
          height:        '100vh',
          display:       'flex',
          flexDirection: 'column',
          boxSizing:     'border-box',
        }}
      >
        {/* ── Header ─────────────────────────────────────────────────────── */}
        <div style={{ position: 'relative', zIndex: 20, flexShrink: 0 }}>
          <Label n="03" text="Reviews" />

          <div style={{
            display:        'flex',
            alignItems:     isMobile ? 'flex-start' : 'baseline',
            flexDirection:  isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            gap:            isMobile ? '0.4rem' : '1rem',
            marginBottom:   isMobile ? '1.5rem' : '2.5rem',
          }}>
            <div style={{
              fontFamily:    'Syne, sans-serif',
              fontSize:      isMobile
                ? 'clamp(1.6rem, 8vw, 2.2rem)'
                : 'clamp(2rem, 4vw, 3.2rem)',
              fontWeight:    800,
              letterSpacing: '-0.05em',
              lineHeight:    0.9,
              color:         'var(--white)',
            }}>
              Kind <span style={{ color: 'var(--acid)' }}>Words</span>
            </div>

            <div style={{
              fontFamily:    'Space Mono, monospace',
              fontSize:      isMobile ? '0.44rem' : '0.5rem',
              color:         '#333',
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
            }}>
              {REVIEWS.length} testimonials
            </div>
          </div>

          <div style={{ height: '1px', background: '#131313', marginBottom: isMobile ? '1.5rem' : '2.5rem' }} />
        </div>

        {/* ── Card stack stage ─────────────────────────────────────────────
            Kept exactly the same as original — flex centering preserved.
            Only the card width changes inside ReviewCard below.
        ──────────────────────────────────────────────────────────────────── */}
        <div style={{
          position:       'relative',
          zIndex:         10,
          flex:           1,
          display:        'flex',
          alignItems:     'center',
          justifyContent: 'center',
        }}>
          {REVIEWS.map((review, i) => (
            <ReviewCard
              key={review.id}
              review={review}
              ref={el => cardRefs.current[i] = el}
              isMobile={isMobile}
            />
          ))}
        </div>

        {/* ── Footer hint ─────────────────────────────────────────────────── */}
        <div style={{
          position:      'absolute',
          bottom:        isMobile ? '1.5rem' : '2rem',
          right:         '5vw',
          fontFamily:    'Space Mono, monospace',
          fontSize:      '0.38rem',
          color:         '#1c1c1c',
          letterSpacing: '0.16em',
          textTransform: 'uppercase',
        }}>
          Scroll to read
        </div>
      </section>
    </div>
  );
}

// ─── Card ─────────────────────────────────────────────────────────────────────
const ReviewCard = forwardRef(function ReviewCard({ review, isMobile }, ref) {
  // ONLY change from original: wider card width
  // Desktop: 86vw (was min(44vw,520px)) — fills the section, leaving ~7vw each side via section padding
  // Mobile: min(82vw, 340px) — unchanged
  const cardW = isMobile ? 'min(82vw, 340px)' : '86vw';

  return (
    <div
      ref={ref}
      style={{
        position:     'absolute',  // kept exactly as original
        width:        cardW,
        background:   '#0b0b0b',
        border:       '1px solid #1a1a1a',
        borderRadius: '6px',
        padding:      isMobile ? '1.4rem 1.2rem' : '2.2rem 2rem',
        boxSizing:    'border-box',
        willChange:   'transform',
        boxShadow:    '0 12px 60px rgba(0,0,0,0.6), 0 2px 8px rgba(0,0,0,0.4)',
      }}
    >
      {/* Top row: index + tag */}
      <div style={{
        display:        'flex',
        justifyContent: 'space-between',
        alignItems:     'center',
        marginBottom:   isMobile ? '1rem' : '1.6rem',
      }}>
        <span style={{
          fontFamily:    'Space Mono, monospace',
          fontSize:      '0.38rem',
          color:         '#222',
          letterSpacing: '0.14em',
        }}>
          {review.id}
        </span>
        <span style={{
          fontFamily:    'Space Mono, monospace',
          fontSize:      '0.38rem',
          color:         'var(--acid)',
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          border:        '1px solid #1e2800',
          borderRadius:  '2px',
          padding:       '0.2rem 0.5rem',
        }}>
          {review.tag}
        </span>
      </div>

      {/* Quote mark */}
      <div style={{
        fontFamily:    'Syne, sans-serif',
        fontSize:      isMobile ? '2.4rem' : '3.5rem',
        lineHeight:    0.7,
        color:         '#151515',
        marginBottom:  isMobile ? '0.6rem' : '0.8rem',
        userSelect:    'none',
      }}>
        "
      </div>

      {/* Review text */}
      <p style={{
        fontFamily:   'Space Mono, monospace',
        fontSize:     isMobile
          ? 'clamp(0.5rem, 2.2vw, 0.65rem)'
          : 'clamp(0.6rem, 1vw, 0.78rem)',
        lineHeight:   1.8,
        color:        'var(--white)',
        opacity:      0.75,
        margin:       0,
        marginBottom: isMobile ? '1.2rem' : '2rem',
      }}>
        {review.text}
      </p>

      {/* Divider */}
      <div style={{ height: '1px', background: '#131313', marginBottom: isMobile ? '0.8rem' : '1.2rem' }} />

      {/* Reviewer info */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div>
          <div style={{
            fontFamily:    'Syne, sans-serif',
            fontSize:      isMobile ? '0.6rem' : '0.75rem',
            fontWeight:    700,
            color:         'var(--white)',
            letterSpacing: '-0.02em',
            marginBottom:  '0.15rem',
          }}>
            {review.name}
          </div>
          <div style={{
            fontFamily:    'Space Mono, monospace',
            fontSize:      '0.38rem',
            color:         '#444',
            letterSpacing: '0.06em',
          }}>
            {review.role}
          </div>
        </div>

        <span style={{
          fontFamily:    'Space Mono, monospace',
          fontSize:      '0.38rem',
          color:         '#1c1c1c',
          letterSpacing: '0.1em',
        }}>
          {review.year}
        </span>
      </div>
    </div>
  );
});

// ─── Easings ──────────────────────────────────────────────────────────────────
function easeOutBack(t) {
  const c1 = 1.70158;
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
}